/**
 * @import {RegistryEngine} from '@acng/frontend-stargazer';
 */

import {task} from '@acng/frontend-stargazer';
import {createFrontendFeature} from '../../core/model/feature.js';
import {hasFeature} from '../../core/service/env.js';
import {authUser} from '../../userPool/context/auth-user.js';
import {setup} from './match.js';
let initialized = false;

const name = 'hotornot';

export const feature = createFrontendFeature('hotornot');
feature.hidden = !hasFeature(name);

/**
 * @param {Element} element
 * @param {string} value
 * @param {RegistryEngine} compiler
 */
export const compile = (element, value, compiler) => {
  if (feature.hidden || !authUser) {
    element.remove();
  } else if (!initialized) {
    //task(compiler, init());
    //task(compiler, setup());
    initialized = true;
  }
};
